import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Card,
  Dialog,
  DialogActions, DialogContent, DialogTitle, CardContent, Select,Divider  
} from "@mui/material";
import { FaMoneyBillWave, FaPlusCircle ,FaFileAlt, FaClipboardList , FaChartPie , FaCog , FaMoneyCheckAlt, FaChartBar } from 'react-icons/fa'; // Example icons

import { useNotifier } from "../../../Core/Notifier";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../../Components/Pagination";
import axios from "axios";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DescriptionIcon from '@mui/icons-material/Description';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CommentIcon from '@mui/icons-material/Comment';
import { Tooltip as MuiTooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';  
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import LoopIcon from '@mui/icons-material/Loop';           // Circular arrow, used for Before
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined'; // Outlined circular arrow, used for After
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  ICompanyDetails,
  IInvoice,
  ICustomer,
  IQuoteWorkOrder,
  ProductSale,
  IProductPopUP,
  IVariantPopUP
} from "../../../Api/Interface/api.interface";
import {
  useDeleteCustomerMutation,
  useGetAllInvoiceQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetWorkOrderQuery,
  useGetVariantQuery,
  useGetProductQuery,
} from "../../../Api/attoDeskApi";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import { WorkOrderStatus } from "../../../Core/Enum/enum";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import moment from "moment";
import dayjs from "dayjs";

ChartJS.register(ArcElement, Tooltip, Legend);

interface Expense {
  id: number;
  date: string;
  description: string;
  remarks: string;
  amount: number;
  hst: number;
  category: number;
  status: number;
  total: number;
  file?: string;
  created_at: string;
  before_images?: string;
  after_images?: string;
}

interface Category {
  id: number;
  category_name: string;
}

interface Driver {
  id: number;
  driverFirstName: string;
  driverLastName: string;
  driverUserRole: string;
}

interface Deposit {
  id: number;
  amount: string;
  user_id: number;
  created_at: string;
  date: string;
  is_approved: boolean; 
  remarks: string;
}

interface UserInfo {
  id: number;
  username: string;
  token: string;
  user_id: number;
  role?: string;
}

interface Payment {
  id: number;
  work_order_id: number;
  amount: number;
  payment_method: string;
  created_at: string;
  InvoiceNo: string;
}




const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
   case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};


const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState<Expense[]>([]); 
  const [categories, setCategories] = useState<Category[]>([]); 
  const [team, setTeam] = useState<Driver[]>([]); 
  const [deposit, setDeposit] = useState<Deposit[]>([]); 
  const { showErrorMessage, showMessage } = useNotifier();
  const API_URL = process.env.REACT_APP_API_URL;
  const [searchQuery, setSearchQuery] = useState(""); 
  const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(50);
const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
const [openModal, setOpenModal] = useState(false);
const [openModalView, setOpenModalView] = useState(false);
const [fileUrl, setFileUrl] = useState<string | null>(null);
const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
const [tooltipOpen, setTooltipOpen] = React.useState<Record<number, boolean>>({});
const [showImages, setShowImages] = useState(false);
const [beforeImages, setBeforeImages] = useState<string[]>([]);
const [afterImages, setAfterImages] = useState<string[]>([]);
const isPdf = fileUrl?.endsWith('.pdf');
const [currentSearchQuery, setCurrentSearchQuery] = useState("");
const debouncedSearchQuery = useDebounce(searchQuery, 300);
const [totalInvoiceCount, setTotalInvoiceCount] = useState(0);
const [totalPayments, setTotalPayments] = useState(0);
const [posPayments, setPosPayments] = useState(0);
const [manualPayments , setManualPayments] = useState(0);
const [totalClients, setTotalClients] = useState<number>(0);  
const componentRef = useRef<HTMLDivElement>(null);
  const [dateFilter, setDateFilter] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

const { data, isLoading, isError, refetch } = useGetAllInvoiceQuery({
  searchText: currentSearchQuery,
  id: "",
  quoteWorkOrderCustomerId: "",
  quoteWorkOrderCustomerProjectId: "",
});

 const { data: variantData, isLoading: variantLoading } =
    useGetVariantQuery({  searchText: "",
    id: null,
    productId: null,
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });
  const { data: productData, isLoading: productIsLoading, isError: productIsError, refetch: refetchProduct } = useGetProductQuery({
    searchText: "",
    id: null,
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });


// 🔥 Define `coursings` at the top so it's available everywhere
const coursings: IInvoice[] = Array.isArray(data?.data) ? (data?.data as IInvoice[]) : [];
const [monthlyPayments, setMonthlyPayments] = useState<number[]>([]);
const [todaysBookings, setTodaysBookings] = useState<IInvoice[]>([]);
const [lastestInvoices, setLatestInvoices] = useState<IInvoice[]>([]);
const [dueInvoices, setDueInvoices] = useState<IInvoice[]>([]);
const [payments, setPayments] = useState<Payment[]>([]); 
const [monthlyInvoiceCounts, setMonthlyInvoiceCounts] = useState<number[]>(Array(12).fill(0));
const [selectedMethod, setSelectedMethod] = useState('');
const [selectedMode, setSelectedMode] = useState('');
const [accessibleInvoices, setAccessibleInvoices] = React.useState<IInvoice[]>([]);


// const variants: IVariantPopUP[] = Array.isArray(variantData?.data)
//   ? variantData.data
//   : [];

// const products: IProductPopUP[] = Array.isArray(productData?.data)
//   ? productData.data
//   : [];




// useEffect(() => {
//   if (!isLoading && data?.data) {
//     const todayDateString = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD in local time

//     const filteredBookings = coursings.filter((invoice) =>
//       invoice.quoteWorkOrderSale?.some((sale: any) => {
//         if (!sale.departureDateTime) return false;

//         const saleDate = new Date(sale.departureDateTime).toLocaleDateString("en-CA"); // Convert to local date
//       //  console.log(`Comparing ${saleDate} with ${todayDateString}`);

//         return saleDate === todayDateString;
//       })
//     );

//     setTodaysBookings(filteredBookings); // ✅ Update state after filtering
//   }
// }, [isLoading, data]); 


React.useEffect(() => {
  if (
    !userInfo?.id ||
    !userInfo?.role ||
    !variantData ||
    !productData ||
    !Array.isArray(coursings)
  ) {
    return;
  }

  const variants: IVariantPopUP[] = Array.isArray(variantData.data)
    ? variantData.data
    : [];

  const products: IProductPopUP[] = Array.isArray(productData.data)
    ? productData.data
    : [];

  let filtered: IInvoice[] = [];

  if (["Staff", "Coordinator"].includes(userInfo.role)) {
    filtered = coursings.filter((invoice) => {
      let saleItems: any[] = [];

      try {
        saleItems =
          typeof invoice.quoteWorkOrderSale === "string"
            ? JSON.parse(invoice.quoteWorkOrderSale)
            : invoice.quoteWorkOrderSale;
      } catch {
        return false;
      }

      return saleItems.some((item) => {
        const variant = variants.find(
          (v) => Number(v.id) === Number(item.productId)
        );
        if (!variant) return false;

        const product = products.find(
          (p) => Number(p.id) === Number(variant.productId)
        );
        if (!product) return false;

        let userIds: number[] = [];
        if (Array.isArray(product.user_ids)) userIds = product.user_ids;
        else if (typeof product.user_ids === "string") {
          try {
            userIds = JSON.parse(product.user_ids);
          } catch {
            userIds = [];
          }
        }

        return userIds.length === 0 || userIds.includes(Number(userInfo.id));
      });
    });
  } else {
    // Admin / Manager
    filtered = coursings;
  }

  setAccessibleInvoices(filtered);
}, [userInfo, variantData, productData, coursings]);







useEffect(() => {
  if (!Array.isArray(accessibleInvoices)) return;  // ✅ Ensure data exists
    // Sort by created_at or updated_at (descending order)
    const sortedInvoices = [...accessibleInvoices].sort((a: any, b: any) => 
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );

    // Get the latest 10 invoices
    setTodaysBookings(sortedInvoices.slice(0, 10));

    const monthlyCounts = Array(12).fill(0); // Initialize array for 12 months

    sortedInvoices.forEach((invoice: any) => {
      const monthIndex = new Date(invoice.created_at).getMonth(); // Get month index (0-11)
      monthlyCounts[monthIndex] += 1; // Increment count for that month
    });

    setMonthlyInvoiceCounts(monthlyCounts);
  
}, [accessibleInvoices]);


useEffect(() => { 
  if (!isLoading && data && Array.isArray(data.data)) {  
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

    // ✅ Filter invoices where due_date is today
    const dueInvoices = data.data.filter((invoice: any) => {
      const dueDate = invoice.quoteWorkOrderDueDate?.split("T")[0]; // Extract YYYY-MM-DD
      return dueDate === today;
    });

    // ✅ Sort by created_at in descending order
    const sortedInvoices = [...dueInvoices].sort((a: any, b: any) => 
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );

    // ✅ Get the latest 10 due invoices
    setDueInvoices(sortedInvoices.slice(0, 10));
  }
}, [isLoading, data]);



useEffect(() => {
  fetch(`${API_URL}/payments`)
    .then((res) => res.json())
    .then((data) => {
      setPayments(data);
    })
    .catch((err) => console.error('Error fetching payments:', err));
}, []);




const filteredPayments = payments.filter((row) => {

  const matchesDate =
    !dateFilter || (() => {
      if (!row.created_at) return false; 

        const paymentDate = new Date(row.created_at).toLocaleDateString("en-CA");
        const startDateString = new Date(startDate).toLocaleDateString("en-CA");
        const endDateString = new Date(endDate).toLocaleDateString("en-CA");

        const isValid = paymentDate >= startDateString && paymentDate <= endDateString;
        return isValid;
      })();

      const matchesMethod = !selectedMethod || row.payment_method === selectedMethod;

      const matchedInvoice = todaysBookings.find(
        (item) => item.work_order_id === row.work_order_id
      );
     if (!matchedInvoice) return false;
      const mode = matchedInvoice?.Mode || "Manual";
    
      const matchesMode = !selectedMode || mode === selectedMode;

  return matchesDate && matchesMethod && matchesMode;
});




useEffect(() => {
  if (!accessibleInvoices || accessibleInvoices.length === 0) return;
 
    const invoiceCount = accessibleInvoices.length;
    const invoiceAmount = accessibleInvoices.reduce((sum, invoice) => sum + Number(invoice.amount || 0), 0);
    const totalPayments = accessibleInvoices.reduce((sum, invoice) => sum + Number(invoice.amount_paid || 0), 0);
    const posPayments = accessibleInvoices.reduce((sum, invoice) => {
     return invoice.Mode === 'POS' ? sum + Number(invoice.amount_paid || 0) : sum;
    }, 0);
    const manualPayments = totalPayments - posPayments;


    setTotalInvoiceCount(invoiceCount);
    setTotalPayments(totalPayments);
    setPosPayments(posPayments); 
    setManualPayments(manualPayments); 
  
}, [accessibleInvoices]);

// console.log("Filtered Invoices:", todaysBookings);

useEffect(() => {
  if (!userInfo?.id || !accessibleInvoices) return;

  axios.get(`${API_URL}/monthly-payments`)
    .then((response) => {
       const filtered = response.data.filter((payment: any) => 
        accessibleInvoices.some(inv => inv.work_order_id === payment.work_order_id)
      );

      setMonthlyPayments(generateMonthlyPaymentsData(filtered));
    })
    .catch((error) => console.error("Error fetching payments:", error));
}, []);


  useEffect(() => {
      if (dateFilter !== "custom") {
        let start = "";
        let end = dayjs().format("YYYY-MM-DD");
  
        switch (dateFilter) {
          case "today":
            start = end;
            break;
          case "yesterday":
            start = dayjs().subtract(1, "day").format("YYYY-MM-DD");
            end = start;
            break;
          case "this_week":
            start = dayjs().startOf("week").format("YYYY-MM-DD");
            break;
          case "last_week":
            start = dayjs().subtract(1, "week").startOf("week").format("YYYY-MM-DD");
            end = dayjs().subtract(1, "week").endOf("week").format("YYYY-MM-DD");
            break;
          case "this_month":
            start = dayjs().startOf("month").format("YYYY-MM-DD");
            break;
          case "last_month":
            start = dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
            end = dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
            break;
          default:
            break;
        }
  
        setStartDate(start);
        setEndDate(end);
      }
    }, [dateFilter]);
 


const generateMonthlyPaymentsData = (payments: { month: number; total_payments: any }[]) => {
  const monthlyPaymentsData = Array(12).fill(0); // Initialize array with 12 months

  payments.forEach((payment) => {
    const monthIndex = payment.month - 1; // Convert month (1-12) to array index (0-11)
    monthlyPaymentsData[monthIndex] = parseFloat(String(payment.total_payments) || "0"); // Ensure it's a string before parsing
  });

  return monthlyPaymentsData;
};




const handleViewImages = (beforeImagesData: string[], afterImagesData: string[]) => {
  console.log("Before Images Data:", beforeImagesData);  // This should now show the images
  setBeforeImages(beforeImagesData || []);
  setAfterImages(afterImagesData || []);
  setOpenModalView(true);
};


 // Handle tooltip open for desktop (hover) and mobile (tap)
 const handleTooltipOpen = (id: number) => {
  if (window.innerWidth > 768) {
    setTooltipOpen((prev) => ({ ...prev, [id]: true })); // Open tooltip on hover for desktop
  }
};

const handleTooltipClose = (id: number) => {
  if (window.innerWidth > 768) {
    setTooltipOpen((prev) => ({ ...prev, [id]: false })); // Close tooltip on hover leave for desktop
  }
};

// Handle touch on mobile
const handleMobileTooltipToggle = (id: number) => {
  if (window.innerWidth <= 768) {
    setTooltipOpen((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the open state for the specific tooltip
    })); // Toggle open/close on tap for mobile
  }
};

const categoryMap = useMemo(
  () =>
    categories.reduce((map, category) => {
      map[category.id] = category.category_name;
      return map;
    }, {} as Record<number, string>),
  [categories]
);

  const filteredExpenses = expenses.filter(
    (expense) =>
      expense.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (categoryMap[expense.category] || "")
    .toLowerCase()
    .includes(searchQuery.toLowerCase())
);

const totalHst = filteredExpenses.reduce((sum, expense) =>  {
  return sum + (Number(expense.hst) || 0);
}, 0);

const totalAmount = filteredExpenses.reduce((sum, expense) => {
  return sum + (Number(expense.amount) || 0);
}, 0);

const totalAmountWithTax = filteredExpenses.reduce((sum, expense) => {
  return sum + (Number(expense.total) || 0);
}, 0);



  const handleEditClick = (id: number) => {
    navigate(`/expense/${id}`);
  };

  const handleDeleteClick = (id: number) => {
    // Delete expense logic
    axios.delete(`${API_URL}/delete-expense/${id}`).then(() => {
      setExpenses(expenses.filter((expense) => expense.id !== id));
      showMessage("Deleted successfully");
    }).catch((error) => {
     // console.error("Failed to delete expense", error);
      showErrorMessage("Failed to delete the template");
    });
  };

    useEffect(() => {
      if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
        setCurrentSearchQuery(debouncedSearchQuery);
        refetch();
      }
    }, [debouncedSearchQuery]);

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-expenses`);
        setExpenses(response.data); // Set the fetched data to state
    
        
      } catch (error) {
        console.error("Failed to load expenses", error);
      }
    };


    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-expense-category`);
        setCategories(response.data);
        //console.log(response.data);
      } catch (error) {
        console.error("Failed to load categories", error);
      }
    };
    const fetchTeam = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-team`);
        // setTeam(response.data.data);
        const team: Driver[] = response.data.data;
        const managers = team.filter(driver => driver.driverUserRole === 'manager');
        setTeam(managers); 
       // console.log(response.data.data);
      } catch (error) {
        console.error("Failed to load team members", error);
      }
    };

    const fetchDeposit = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-deposit`);
        setDeposit(response.data); // Set the fetched data to state
        // console.log(response.data);
      } catch (error) {
        console.error("Failed to load expenses", error);
      }
    };

    const fetchUserInfo = async () => {
      try {
          const response = await axios.post(
              `${API_URL}/user/userInfo`,
              {}, // No body required
              {
                  headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // Include token from localStorage
                  },
              }
          );
          setUserInfo(response.data.data); // Update your state with the response
        //console.log(response.data.data)
      } catch (error) {
          console.error('Error fetching user info', error);
      }
  };

  const fetchCustomerList = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/customer/getAll`, // ✅ Endpoint
        {}, // No body required
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // ✅ Include auth token
          },
        }
      );
      const customers = response.data.data;
      const activeClients = customers.filter((customer: any) => customer.isDelete === 0);
      setTotalClients(activeClients.length);
    } catch (error) {
      console.error('Error fetching customers', error);
  
    }
  }

    fetchExpenses();
    fetchCategories();
    fetchTeam();
    fetchDeposit();
    fetchUserInfo();
    fetchCustomerList();
  }, [API_URL]);

 
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const summary = React.useMemo(() => {
  const result = {
    Online: { total: 0, Credit: 0, Debit: 0, Cash: 0, Due: 0 },
    POS: { total: 0, Credit: 0, Debit: 0, Cash: 0, Due: 0 },
  };

  filteredPayments.forEach((row: Payment) => {
    const matchedInvoice = todaysBookings.find(
      (item) => item.work_order_id === row.work_order_id
    );

    const mode = matchedInvoice?.Mode || "Manual";

    if (mode === "Online" || mode === "POS") {
      result[mode].total += Number(row.amount);

      if (row.payment_method === "Credit")
        result[mode].Credit += Number(row.amount);

      if (row.payment_method === "Debit")
        result[mode].Debit += Number(row.amount);

      if (row.payment_method === "Cash")
        result[mode].Cash += Number(row.amount);

      if (row.payment_method === "Due")
        result[mode].Due += Number(row.amount);
    }
  });

  return result;
}, [filteredPayments, todaysBookings]);

  
const SummaryRow = ({
  label,
  value,
  isDue = false,
}: {
  label: string;
  value: number;
  isDue?: boolean;
}) => (
  <Grid
    container
    justifyContent="space-between"
    alignItems="center"
    sx={{ mb: 1.5 }}
  >
    <Typography>{label}:</Typography>
    <Typography
      fontWeight={label === "Total" ? "bold" : 500}
      color={isDue ? "error" : "text.primary"}
    >
      ${value.toLocaleString()}
    </Typography>
  </Grid>
);


  const generateYearlyData = (expenses: Expense[]) => {
    const yearlyData = Array(12).fill(0); // Array to store expenses for each month (12 months)
  
    expenses.forEach((expense) => {
      const expenseDate = new Date(expense.date);
      const month = expenseDate.getMonth(); // Get month (0-11)
      
      // Ensure expense.total is a number
      let totalExpense = expense.total;
      
      if (typeof totalExpense === 'string') {
        totalExpense = parseFloat(totalExpense); // Convert string to number
      }
    
      // Check if totalExpense is a valid number
      if (!isNaN(totalExpense)) {
        yearlyData[month] += totalExpense; // Aggregate expense by month
      } else {
        console.error("Invalid total expense:", expense.total); // Log invalid total
      }
    });
  
    // Ensure that no NaN values are in yearlyData
    const validYearlyData = yearlyData.map((value) => (isNaN(value) ? 0 : value)); // Replace NaN with 0
  
    //console.log(validYearlyData); // Check the data
    return validYearlyData;
  };
  
  
  const generateCategoryData = (expenses: Expense[], categories: Category[]) => {
    const categoryTotals: Record<string, number> = {};

    // Map category ID to category name
    const categoryMap = categories.reduce((acc, category) => {
      acc[category.id] = category.category_name;
      return acc;
    }, {} as Record<number, string>);

    expenses.forEach((expense) => {
      let totalExpense = expense.total;

      // Ensure totalExpense is a number
      if (typeof totalExpense === 'string') {
        totalExpense = parseFloat(totalExpense); // Convert string to number
      }

      // Get the category name using the category ID
      const categoryName = categoryMap[expense.category];

      if (categoryName) {
        //console.log(`Processing Category: ${categoryName}, Total Expense: ${totalExpense}`);

        // Check if totalExpense is a valid number
        if (!isNaN(totalExpense)) {
          if (!categoryTotals[categoryName]) {
            categoryTotals[categoryName] = 0;
          }
          categoryTotals[categoryName] += totalExpense; // Aggregate by category name
        } else {
          console.error("Invalid category total:", expense.total);
        }
      } else {
        console.error("Invalid category ID:", expense.category);
      }
    });

    // Ensure that no NaN values are in categoryTotals
    const validCategoryTotals = Object.fromEntries(
      Object.entries(categoryTotals).map(([key, value]) => [key, isNaN(value) ? 0 : value])
    );

    //console.log('Final Category Totals:', validCategoryTotals);
    return validCategoryTotals;
  };
  
  
  
  
  const categoryData = generateCategoryData(expenses, categories);
  const yearlyData = generateYearlyData(expenses);
  

  const handleAddProductClick = () => {
    navigate("/expense/create");
  };

  const handleAddCategoryClick = () => {
    navigate("/expense-category/list");
  };

  const chartData = [
    { name: "Total HST", y: totalHst },
    { name: "Total Amount (Without hst)", y: totalAmount },
    // { name: "Total Amount (with hst)", y: totalAmountWithTax }
  ];
  
  // Highcharts options
  const chartOptions = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      height: 350,
      width: 250,
    },
    title: {
      text: " ",
      align: "left",
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        innerSize: "40%",
      },
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "top",
      symbolRadius: 0,
      itemStyle: {
        fontWeight: "normal",
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'Expenses',
        colorByPoint: true,
        data: chartData, // Data for the three totals
      },
    ],
  };

  const parseFiles = (file: string | undefined): string[] => {
    try {
      return file ? JSON.parse(file) : [];
    } catch (error) {
      return [];
    }
  };
  // Function to handle opening the modal
  const handleOpenModal = (file: string): void => {
    const url = `${LARAVEL_API_URL}/${file}`;
    setFileUrl(url);
    setOpenModal(true);
  };

  // Function to handle closing the modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setFileUrl(null);
  };

  const handleCloseModalView = () => {
    setOpenModalView(false);
   // setFileUrl(null);
  };

  const handleDepositClick = (id: any) => {
    // console.log(`${id} Deposit Clicked`);
   // navigate("/deposit/create");
    navigate("/deposit/create", { state: { userId: id } });
  };


  const lineChartOptions = {
    chart: {
      type: 'line',
      height: 350,
      // width: 500,
    },
    title: {
      text: 'Yearly Expense Trend',
    },
    xAxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    yAxis: {
      title: {
        text: 'Expense Amount ($)',
      },
    },
    credits: {
      enabled: false, // Disable the watermark
    },
    series: [
      {
        name: 'Total Expense',
        data: yearlyData,
      },
    ],
    
  };

  const paymentsLineChartOptions = {
    chart: {
      type: 'line',
      height: 350,
    },
    title: {
      text: 'Monthly Payments Trend',
    },
    xAxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    // yAxis: {
    //   title: {
    //     text: 'Payments Amount ($)',
    //   },
    // },
    yAxis: [
  {
    title: {
      text: 'Payments Amount ($)',
    },
  },
  {
    title: {
      text: 'Invoice Count',
    },
    opposite: true, // Places it on the right side
    // tickInterval: 5, 
  },
],

    credits: {
      enabled: false, // Disable watermark
    },
    // series: [
    //   {
    //     name: 'Total Payments',
    //     data: monthlyPayments, // Processed data
    //   },
    // ],
    
   series: [
  {
    name: 'Total Payments',
    type: 'line',
    data: monthlyPayments,
    yAxis: 0,
    // color: '#007bff', // blue
  },
  {
    name: 'Invoice Count',
      type: 'line',
    data: monthlyInvoiceCounts,
    yAxis: 1,
    // color: '#ffc107', // yellow
  },
  ],
  };
  

  const paymentsPieChartOptions = {
    chart: {
      type: 'pie',
      height: 350,
    },
    title: {
      text: 'Total Invoice',
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b> ({point.percentage:.1f}%)',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
        },
      
      },
    },
    credits: {
      enabled: false, // Disable watermark
    },
    series: [
      {
        name: 'Invoice Count',
        colorByPoint: true,
        data: [
          { name: 'January', y: monthlyInvoiceCounts[0] },
          { name: 'February', y: monthlyInvoiceCounts[1] },
          { name: 'March', y: monthlyInvoiceCounts[2] },
          { name: 'April', y: monthlyInvoiceCounts[3] },
          { name: 'May', y: monthlyInvoiceCounts[4] },
          { name: 'June', y: monthlyInvoiceCounts[5] },
          { name: 'July', y: monthlyInvoiceCounts[6] },
          { name: 'August', y: monthlyInvoiceCounts[7] },
          { name: 'September', y: monthlyInvoiceCounts[8] },
          { name: 'October', y: monthlyInvoiceCounts[9] },
          { name: 'November', y: monthlyInvoiceCounts[10] },
          { name: 'December', y: monthlyInvoiceCounts[11] },
        ],
      },
    ],
  };

 const paymentsDoughnutChartOptions = {
  chart: {
    type: 'pie',
    height: 350,
  },
  title: {
    text: 'Total Revenue',
  },
  tooltip: {
    pointFormat: '{series.name}: <b>${point.y}</b> ({point.percentage:.1f}%)',
  },
  colors: [
    '#FF5733', '#33FF57', '#3357FF', '#FF33A8', '#33FFF6', '#FFD733', '#9D33FF', 
    '#FF5733', '#FF8C33', '#33FFB5', '#B533FF', '#FF3333'
  ], // 🎨 Custom color palette
  plotOptions: {
    pie: {
      innerSize: '60%', // 🔹 Doughnut shape
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        format: '<b>{point.name}</b>: {point.percentage:.1f} %',
      },
    },
  },
  credits: {
    enabled: false, // Disable watermark
  },
  series: [
    {
      name: 'Revenue',
      colorByPoint: true, // 🔹 Ensures different colors
      data: [
        { name: 'January', y: monthlyPayments[0] },
        { name: 'February', y: monthlyPayments[1] },
        { name: 'March', y: monthlyPayments[2] },
        { name: 'April', y: monthlyPayments[3] },
        { name: 'May', y: monthlyPayments[4] },
        { name: 'June', y: monthlyPayments[5] },
        { name: 'July', y: monthlyPayments[6] },
        { name: 'August', y: monthlyPayments[7] },
        { name: 'September', y: monthlyPayments[8] },
        { name: 'October', y: monthlyPayments[9] },
        { name: 'November', y: monthlyPayments[10] },
        { name: 'December', y: monthlyPayments[11] },
      ],
    },
  ],
};

  
  
  
  // Bar Chart (Expense Category)
  const barChartOptions = {
    chart: {
      type: 'column',
      height: 350,
      // width: 500,
    },
    title: {
      text: 'Expense by Category',
    },
    xAxis: {
      categories: categories.map((category) => category.category_name), // Category names
    },
    yAxis: {
      title: {
        text: 'Expense Amount ($)',
      },
    },
    credits: {
      enabled: false, // Disable the watermark
    },
    series: [
      {
        name: 'Expense',
        data: categories.map((category) => categoryData[category.category_name] || 0), // Ensure the data is mapped correctly to the categories
      },
    ],
  };


 const calculateCategoryHST = (expenses: Expense[], categories: Category[]) => {
  const categoryHST: Record<string, number> = {};

  const categoryMap = categories.reduce((acc, category) => {
    acc[category.id] = category.category_name;
    return acc;
  }, {} as Record<number, string>);

  expenses.forEach((expense) => {
    const hst = Number(expense.hst) || 0; // Use the existing value or default to 0
    const categoryName = categoryMap[expense.category];

    if (categoryName) {
      categoryHST[categoryName] = (categoryHST[categoryName] || 0) + hst;
    }
  });

  return categoryHST;
};

// Example Usage
const categoryHST = calculateCategoryHST(expenses, categories);
const totalBankBalance = deposit.filter((d) => d.is_approved).reduce((acc, curr) => acc + Number(curr.amount), 0);
const overallExpense = expenses.reduce((acc, expense) => acc + Number(expense.total), 0);
const paidExpense =  expenses
.filter(expense => String(expense.status) === 'Paid')  // Convert status to string
.reduce((total, expense) => total + expense.amount, 0); 


const calculatePieData = (categoryName: string) => {
  const totalExpense = categoryData[categoryName] || 0;
  const totalHST = categoryHST[categoryName] || 0;
  const overallExpensePercentage = ((totalExpense / overallExpense) * 100).toFixed(2);

  return {
    labels: [`${categoryName} %`, `Overall Expense`],
    datasets: [
      {
        data: [totalExpense, overallExpense], // Data for percentage and total expense
        backgroundColor: ['#4CAF50', '#FF9800'], // Green for percentage, Orange for overall expense
        hoverOffset: 4,
      },
    ],
  };
};


const handleApproveDeposit = (depositId: number) => {
  // API call to approve the deposit (you can use Axios or Fetch)
  axios
    .put(`${API_URL}/deposits/${depositId}/approve`,   { approved_by: userInfo?.user_id } )
    .then((response) => {
      showMessage("Approved successfully");
      // Update the state to reflect the change (this will re-render the UI)
      setDeposit((prevDeposits) =>
        prevDeposits.map((deposit) =>
          deposit.id === depositId ? { ...deposit, is_approved: true } : deposit
        )
      );
    })
    .catch((error) => {
      console.error('Error approving deposit:', error);
    });
};

const calculatePaidExpenses = () => {
  return expenses
    .filter(expense => String(expense.status) === 'Paid') // Ensure status is a string and matches "Paid"
    .reduce((total, expense) => {
      // Check if the amount is a string and parse it to a number if necessary
      const amount = typeof expense.amount === 'string' ? parseFloat(expense.amount) : expense.amount;
      return total + (isNaN(amount) ? 0 : amount); // If amount is not a valid number, treat it as 0
    }, 0);
};


const formatCurrency = (amount: number) => {
  return amount.toFixed(2); // Format the number to two decimal places
};


// if (!userInfo || !variants || !products) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         height="10vh"
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }










  return (

    
    <>
 
 <Grid container spacing={2} justifyContent="space-between" sx={{ marginTop: 1 }}>
  {[ // array of your 5 cards
    { title: 'Total Invoice', value: totalInvoiceCount, prefix: '', suffix: '' },
    { title: 'Total Payments', value: totalPayments.toFixed(2), prefix: '$', suffix: '' },
    { title: 'Pos Payments', value: posPayments.toFixed(2), prefix: '$', suffix: '' },
    { title: 'Manual Payments', value: manualPayments.toFixed(2), prefix: '$', suffix: '' },
    { title: 'Total Clients', value: totalClients, prefix: '', suffix: '' }
  ].map((item, index) => (
    <Grid item xs={12} sm={6} md={2.4} key={index}>
      <Card elevation={3}>
        <CardContent>
          <Grid container direction="column" alignItems="center">
            <Typography variant="h5" mt={2}>{item.title}</Typography>
            <Typography
              variant="h3"
              sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
            >
              {item.prefix}{item.value}{item.suffix}
            </Typography>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

    
   


    <Grid container spacing={4} justifyContent="center" sx={{ marginTop: 1 }}>
  {team .filter((person) => person.id !== userInfo?.user_id) // Exclude the logged-in user's data
    .map((person, index) => {
    const personDeposits = deposit.filter((d) => d.user_id === person.id); // Filter all deposits for the person

    const personTotalDeposit = personDeposits
      .filter((d) => d.is_approved) // Only include approved deposits for the total calculation
      .reduce((acc, curr) => acc + Number(curr.amount), 0);

    const unapprovedDeposits = personDeposits.filter((d) => !d.is_approved); // Filter out unapproved deposits

    // Only render the Card if there are unapproved deposits for this person
    if (unapprovedDeposits.length === 0) return null;

    return (
      <Grid item xs={12} sm={6} md={6} key={index}>
        <Card elevation={3} sx={{ height: '350px', display: 'flex', flexDirection: 'column' }}>
          <CardContent sx={{ flex: 1 }}>
            <Grid container alignItems="center" mt={1} justifyContent="center" spacing={2}>
              <Grid item>
                <Typography variant="body2" align="center" sx={{ fontWeight: 'bold', fontSize: '15px' }}>
                  {person.driverFirstName} {person.driverLastName}
                </Typography>
              </Grid>
            </Grid>

            {/* Section to approve deposits */}
            {unapprovedDeposits.length > 0 && (
              <Box mt={3}>
                <Typography variant="h6" align="center" sx={{ fontWeight: 'bold' }}>
                  Pending Approvals
                </Typography>
                <Box sx={{ maxHeight: '200px', overflowY: 'auto' }} className={classes.thinScrollbar}>
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow>
                        <TableCell className={classes.tablheader}>Date</TableCell>
                        <TableCell className={classes.tablheader}>Amount</TableCell>
                        <TableCell className={classes.tablheader}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {unapprovedDeposits.map((depositItem, idx) => (
                        <TableRow key={idx}>
                          <TableCell scope="row" className={classes.tablCell}>
                            {new Date(depositItem.created_at).toLocaleDateString()}
                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            ${depositItem.amount}

                            
                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => handleApproveDeposit(depositItem.id)}
                            >
                              Approve
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            )}
          </CardContent>
        </Card>
      </Grid>
    );
  })}
</Grid>




    <Grid container spacing={4}  justifyContent="center" sx={{ marginTop: 3}}>
    <Grid item xs={12} sm={12} md={6} >
      <Card>
        <CardContent>
          <HighchartsReact highcharts={Highcharts} options={paymentsLineChartOptions } />
        </CardContent>
      </Card>
    </Grid>

    <Grid item xs={12} sm={12} md={6}>
      <Card>
        <CardContent>
          <HighchartsReact highcharts={Highcharts} options={barChartOptions} />
        </CardContent>
      </Card>
    </Grid>
  </Grid>

   


<Grid container spacing={4} justifyContent="center" sx={{ marginTop: 1 }}>
  {team.map((person, index) => {

    const personDeposits = deposit.filter(d => d.user_id === person.id ); 
    
    const personTotalDeposit = personDeposits.filter((d) => d.is_approved)
    .reduce((acc, curr) => acc + Number(curr.amount), 0);

    return (
      <Grid item xs={12} sm={6} md={6} key={index}>
        <Card elevation={3} sx={{ height: '350px', display: 'flex', flexDirection: 'column' }}>
          <CardContent sx={{ flex: 1 }}>
            <Grid container alignItems="center" mt={1} justifyContent="center" spacing={2}>
              <Grid item>
                <Typography variant="body2" align="center" sx={{ fontWeight: 'bold', fontSize: '15px' }}>
                  {person.driverFirstName} {person.driverLastName}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h4" align="center" sx={{ fontWeight: 'bold', color: "#4CAF50" }}>
                  ${personTotalDeposit.toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
            <Box display="flex" justifyContent="center" mt={2}>
              <Button
                size="small" 
                variant="contained"
                color="primary"
                onClick={() => handleDepositClick(person.id)}
              >
                Deposit
              </Button>
            </Box>
            <Box
              mt={3}
              sx={{ maxHeight: '200px', overflowY: 'auto' }}
              className={classes.thinScrollbar}
            >
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow>
                    <TableCell className={classes.tablheader}>Date</TableCell>
                    <TableCell className={classes.tablheader}>Amount</TableCell>
                    <TableCell className={classes.tablheader}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {personDeposits.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={3} align="center" className={classes.tablCell}>
                        No Data Available
                      </TableCell>
                    </TableRow>
                  ) : (
                    personDeposits
                    .sort((a, b) => {
                      const dateA = new Date(a.date).getTime();
                      const dateB = new Date(b.date).getTime();
                  
                      // First sort by date (descending)
                      if (dateB !== dateA) {
                        return dateB - dateA;
                      }
                  
                      // If the dates are the same, sort by ID (ascending)
                      return b.id - a.id;
                    }).
                    map((depositItem, idx) => (
                      <TableRow key={idx}>
                        <TableCell scope="row" className={classes.tablCell}>
                          {new Date(depositItem.date).toLocaleDateString()}
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                          ${depositItem.amount}
                          {depositItem.remarks ? (
        <MuiTooltip
          title={depositItem.remarks}
          arrow
          open={tooltipOpen[depositItem.id] || false}
          onOpen={() => handleTooltipOpen(depositItem.id)}
          onClose={() => handleTooltipClose(depositItem.id)}
          disableInteractive
        >
          <InfoIcon
            sx={{
              color: '#2196F3',
              cursor: 'pointer',
              fontSize: '1.1rem',
              marginLeft: '8px',
              verticalAlign: 'middle',
            }} 
            onClick={()=>handleMobileTooltipToggle(depositItem.id)} // Mobile: tap to toggle
            onTouchStart={()=>handleMobileTooltipToggle(depositItem.id)}  
          />
        </MuiTooltip>
      ) : null}
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                          {depositItem.is_approved ? (
                            <CheckCircleIcon sx={{ color: 'green', backgroundColor: '#d4edda', borderRadius: '50%' }} />
                          ) : (
                            <CheckCircleIcon sx={{ color: 'red', backgroundColor: '#f8d7da', borderRadius: '50%' }} />
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    );
  })}
</Grid>

{/* <Grid container spacing={4} sx={{ p: 4 }}>


  <Grid item xs={12} md={6}>
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        ONLINE PAYMENTS
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <SummaryRow label="Total" value={summary.Online.total} />
      <SummaryRow label="Credit" value={summary.Online.Credit} />
      <SummaryRow label="Debit" value={summary.Online.Debit} />
      <SummaryRow label="Cash" value={summary.Online.Cash} />
      <SummaryRow label="Due" value={summary.Online.Due} isDue />
    </Card>
  </Grid>


  <Grid item xs={12} md={6}>
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        POS PAYMENTS
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <SummaryRow label="Total" value={summary.POS.total} />
      <SummaryRow label="Credit" value={summary.POS.Credit} />
      <SummaryRow label="Debit" value={summary.POS.Debit} />
      <SummaryRow label="Cash" value={summary.POS.Cash} />
      <SummaryRow label="Due" value={summary.POS.Due} isDue />
    </Card>
  </Grid>

</Grid> */}






<div ref={componentRef} >
    <Grid container spacing={4}  sx={{ marginTop: 2 }}>
    <Grid item xs={12} sm={12} md={12}> 

    <Card className={classes.card}
    //  style={{height:'390px'}}
     >
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={2} md={2} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>Payments</Typography>
        </Grid>
        
        <Grid
          item
          lg={10}
          md={10}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid 
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{  display: "flex" ,'@media print': {
              display: 'none',
            } }}
          >
  <Grid item lg={2.3} md={3} sm={4} xs={12}>
  {/* <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
    Issue From
  </Typography> */}
  <Select
    className={classes.textField}
    value={selectedMode || ""}
    onChange={(event) => setSelectedMode(event.target.value)}
    displayEmpty
    sx={{
      height: "37px",
      fontSize: "14px",
      padding: "4px",
      minWidth: "120px"
    }}
  >
  <MenuItem value="">Select Mode</MenuItem>
  <MenuItem value="Manual">Manual</MenuItem>
  <MenuItem value="POS">POS</MenuItem>
  <MenuItem value="Online">Online</MenuItem>
  </Select>
</Grid>

<Grid item lg={2.3} md={3} sm={4} xs={12}>
  {/* <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
    Issue From
  </Typography> */}
  <Select
    className={classes.textField}
    value={selectedMethod || ""}
    onChange={(event) => setSelectedMethod(event.target.value)}
    displayEmpty
    sx={{
      height: "37px",
      fontSize: "14px",
      padding: "4px",
      minWidth: "120px"
    }}
  >
  <MenuItem value="">Select Payment Method</MenuItem>
  <MenuItem value="Cash">Cash</MenuItem>
  <MenuItem value="Credit">Credit</MenuItem>
  <MenuItem value="Debit">Debit</MenuItem>
  </Select>
</Grid>

<Grid item lg={2.3} md={3} sm={4} xs={12}>
               {/* <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Date
               </Typography> */}
               <Select
                 className={classes.textField}
                 value={dateFilter}
                 onChange={(e) => setDateFilter(e.target.value)}
                 displayEmpty
                
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">Select date filter</MenuItem>
                 <MenuItem value="today">Today</MenuItem>
                 <MenuItem value="yesterday">Yesterday</MenuItem>
                 <MenuItem value="this_week">This Week</MenuItem>
                 <MenuItem value="last_week">Last Week</MenuItem>
                 <MenuItem value="this_month">This Month</MenuItem>
                 <MenuItem value="last_month">Last Month</MenuItem>
                 <MenuItem value="custom">Custom</MenuItem>
               </Select>
             </Grid>
 
             {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
             {dateFilter === "custom" && (
               <>
              <Grid item lg={2.5} md={3} sm={4} xs={12}>
                   {/* <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     Start Date
                   </Typography> */}
                   <TextField
                   variant="outlined"
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={startDate}
                     onChange={(e) => setStartDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
                     
                   />
                 </Grid>
        <Grid item lg={2.3} md={3} sm={4} xs={12}>
                   {/* <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     End Date
                   </Typography> */}
                   <TextField
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={endDate}
                     onChange={(e) => setEndDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
              
                   />
                 </Grid>
               </>
             )}


            {/* <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Invoice Number .."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid> */}
            {/* {payments.length > 0 && (
  <Grid item>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => componentRef.current}
    />
  </Grid>
)} */}
            
          </Grid>
        </Grid>
      </Grid>

      <Grid>
    <TableContainer
         sx={{
           maxHeight: 450, // Fixed height for the table
           overflowY: 'auto', // Enables vertical scrolling
         }}
         className={classes.thinScrollbar} 
         >
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                {/* <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell> */}
                {/* <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>Invoice Number</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Mode</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Amount</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Method</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Date</strong>
                </TableCell>
             
                {/* <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell> */}
                {/* <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right",  '@media print': {
                    display: 'none',
                  } }}
                >
                  <strong>Actions</strong>
                </TableCell> */}
                
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || filteredPayments.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                filteredPayments
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: Payment, index) => {
                   
                    const matchedInvoice = todaysBookings.find(
                      (item) => item.work_order_id === row.work_order_id
                    );
                
                    // Get the mode if invoice is found
                    const mode = matchedInvoice?.Mode || "Manual"; // fallback to "N/A" if not found


                    return (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        {/* <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell> */}
                
                        {/* <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell> */}
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                          sx={{ whiteSpace: "nowrap" }} 
                        >
                          {row.InvoiceNo}
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                         {mode}
                        </TableCell>
                       
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                        >
                            {"$"}
                                  {row.amount}
                         
                        </TableCell>
                        <TableCell  component="th" scope="row"  className={classes.tablCell}>
                            {row.payment_method}
                        </TableCell>
                       
                        <TableCell component="th" scope="row" className={classes.tablCell}>
                        {moment(row.created_at).format("DD-MMM-YY")}
                         </TableCell>
                      
                        {/* <TableCell scope="row" className={classes.tablCell}>
                          <Button
                            className={classes.statusButtonList}
                            style={{
                              color: statusColor,
                              border: "solid 1px",
                              borderColor: statusColor,
                              borderRadius: "8px",
                            }}
                          >
                            {statusLabel}
                          </Button>
                        </TableCell> */}
                        {/* <TableCell scope="row" className={classes.tablCell} sx={{ textAlign: "right",  '@media print': {
                    display: 'none',
                  } }}>
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >

                        
                            <Grid item>
                              <Button
                                variant="contained"
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/invoice/history/${row.id}`)
                                }
                              >
                                <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Grid>

                           

                          <Grid item>
                          <Button
  variant="contained"
  className={classes.editButtonList}
  onClick={() =>
    navigate(
      row.project?.id
        ? `/invoice/project/edit/${row.id}` // Redirect to project-specific edit page
        : `/invoice/edit/${row.id}` // Redirect to regular edit page
    )
  }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid>

                          
                          </Grid>
                        </TableCell> */}
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
          <Grid  sx={{ '@media print': {
                    display: 'none',
                  } }}
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={accessibleInvoices.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>

      
      </Grid>
    </Card>
   
      </Grid>

     
      </Grid>
      </div>



<div ref={componentRef} >
    <Grid container spacing={4}  sx={{ marginTop: 2 }}>
    <Grid item xs={12} sm={12} md={12}>

    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>Latest Invoices</Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid 
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{  display: "flex" ,'@media print': {
              display: 'none',
            } }}
          >
            <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Invoice Number .."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid>
            {todaysBookings.length > 0 && (
  <Grid item>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => componentRef.current}
    />
  </Grid>
)}
            
          </Grid>
        </Grid>
      </Grid>

      <Grid>
      <TableContainer
           sx={{
             maxHeight: 450, // Fixed height for the table
             overflowY: 'auto', // Enables vertical scrolling
           }}
           className={classes.thinScrollbar} 
           >
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                {/* <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Invoice Number</strong>
                </TableCell>
                  {/* <TableCell className={classes.tablheader}>
                 <strong>Mode</strong>
                  </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Amount</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Paid Amt</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Balance</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Issue From</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Issue For</strong>
                </TableCell>
           
                {/* <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell> */}
                <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right",  '@media print': {
                    display: 'none',
                  } }}
                >
                  <strong>Actions</strong>
                </TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || todaysBookings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                todaysBookings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IInvoice, index) => {
                    const statusLabel = getStatusLabel(
                      row.quoteWorkOrderStatus
                    );
                    const statusColor = getStatusColor(
                      row.quoteWorkOrderStatus
                    );
                    const balance = Math.max(0, parseFloat(row.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(row.amount_paid || "0")));



                    return (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        {/* <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell> */}
                
                        <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                          sx={{ whiteSpace: "nowrap" }} 
                        >
                          {row.InvoiceNo}
                        </TableCell>

                        {/* <TableCell scope="row" className={classes.tablCell}>
                                                  {row.Mode}
                                                </TableCell> */}

                       <TableCell scope="row" className={classes.tablCell}>
                       <Button
                            className={classes.statusButtonList}
                            style={{
                              color: statusColor,
                              backgroundColor: row.quoteWorkOrderStatus === WorkOrderStatus.Paid
                              ? "#e1f8d5"
                              : row.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                              ? "#f8d7da"
                              : row.quoteWorkOrderStatus === WorkOrderStatus.Pending
                              ? "lightyellow"
                                : row.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                              ? "#e2fafa"
                              : "#ffffff", // Fallback for other statuses
                              border: "solid 1px",
                              borderColor: statusColor,
                              borderRadius: "8px",
                              
                            }}
                          >
                            {statusLabel}
                          </Button>
                                             </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                        >
                            {"$"}
                                  {parseFloat(
                                    row.quoteWorkOrderSaleGrandTotal || "0"
                                  ).toFixed(2)}
                         
                        </TableCell>
                        <TableCell  component="th" scope="row"  className={classes.tablCell}>
                            {"$"}{(row.amount_paid || "0" )}
                        </TableCell>
                       
                        <TableCell component="th" scope="row" className={classes.tablCell}>
                         {"$"}{balance.toFixed(2)}
                         </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                          {row.company.companyName || row.project.projectName || ""}
                       
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                          <Grid container>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                            {row.project?.projectName || row.customer?.customerCompanyName || ""}
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                            {row.customer ? (
        `${row.customer.customerFirstName?.charAt(0).toUpperCase() + row.customer.customerFirstName?.slice(1).toLowerCase() || ""} 
        ${row.customer.customerLastName?.charAt(0).toUpperCase() + row.customer.customerLastName?.slice(1).toLowerCase() || ""}`
      ) : ("Walk-in ")}
                            </Grid>
                          </Grid>
                        </TableCell>
                     
                        {/* <TableCell scope="row" className={classes.tablCell}>
                          <Button
                            className={classes.statusButtonList}
                            style={{
                              color: statusColor,
                              border: "solid 1px",
                              borderColor: statusColor,
                              borderRadius: "8px",
                            }}
                          >
                            {statusLabel}
                          </Button>
                        </TableCell> */}
                        <TableCell scope="row" className={classes.tablCell} sx={{ textAlign: "right",  '@media print': {
                    display: 'none',
                  } }}>
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >

                        
                            <Grid item>
                              <Button
                                variant="contained"
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/invoice/history/${row.id}`)
                                }
                              >
                                <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Grid>

                           

                          <Grid item>
                          <Button
  variant="contained"
  className={classes.editButtonList}
  onClick={() =>
    navigate(
      row.project?.id
        ? `/invoice/project/edit/${row.id}` // Redirect to project-specific edit page
        : `/invoice/edit/${row.id}` // Redirect to regular edit page
    )
  }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid>

                          
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
          <Grid  sx={{ '@media print': {
                    display: 'none',
                  } }}
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={accessibleInvoices.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>

      
      </Grid>
    </Card>
   
      </Grid>
      </Grid>
      </div>



      <div ref={componentRef} >
    <Grid container spacing={4}  sx={{ marginTop: 2 }}>
    <Grid item xs={12} sm={6} md={6}> 

    <Card className={classes.card} style={{height:'390px'}}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>Latest Payments</Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid 
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{  display: "flex" ,'@media print': {
              display: 'none',
            } }}
          >
            {/* <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Invoice Number .."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid> */}
            {/* {payments.length > 0 && (
  <Grid item>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => componentRef.current}
    />
  </Grid>
)} */}
            
          </Grid>
        </Grid>
      </Grid>

      <Grid>
      <TableContainer
           sx={{
             maxHeight: 450, // Fixed height for the table
             overflowY: 'auto', // Enables vertical scrolling
           }}
           className={classes.thinScrollbar} 
           >
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                {/* <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell> */}
                {/* <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>Invoice Number</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Mode</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Amount</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Method</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Date</strong>
                </TableCell>
             
                {/* <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell> */}
                {/* <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right",  '@media print': {
                    display: 'none',
                  } }}
                >
                  <strong>Actions</strong>
                </TableCell> */}
                
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || filteredPayments.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                filteredPayments
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: Payment, index) => {
                   
                    const matchedInvoice = todaysBookings.find(
                      (item) => item.work_order_id === row.work_order_id
                    );
                
                    // Get the mode if invoice is found
                    const mode = matchedInvoice?.Mode || "Manual"; // fallback to "N/A" if not found


                    return (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        {/* <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell> */}
                
                        {/* <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell> */}
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                          sx={{ whiteSpace: "nowrap" }} 
                        >
                          {row.InvoiceNo}
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                         {mode}
                        </TableCell>
                       
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                        >
                            {"$"}
                                  {row.amount}
                         
                        </TableCell>
                        <TableCell  component="th" scope="row"  className={classes.tablCell}>
                            {row.payment_method}
                        </TableCell>
                       
                        <TableCell component="th" scope="row" className={classes.tablCell}>
                        {moment(row.created_at).format("DD-MMM-YY")}
                         </TableCell>
                      
                        {/* <TableCell scope="row" className={classes.tablCell}>
                          <Button
                            className={classes.statusButtonList}
                            style={{
                              color: statusColor,
                              border: "solid 1px",
                              borderColor: statusColor,
                              borderRadius: "8px",
                            }}
                          >
                            {statusLabel}
                          </Button>
                        </TableCell> */}
                        {/* <TableCell scope="row" className={classes.tablCell} sx={{ textAlign: "right",  '@media print': {
                    display: 'none',
                  } }}>
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >

                        
                            <Grid item>
                              <Button
                                variant="contained"
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/invoice/history/${row.id}`)
                                }
                              >
                                <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Grid>

                           

                          <Grid item>
                          <Button
  variant="contained"
  className={classes.editButtonList}
  onClick={() =>
    navigate(
      row.project?.id
        ? `/invoice/project/edit/${row.id}` // Redirect to project-specific edit page
        : `/invoice/edit/${row.id}` // Redirect to regular edit page
    )
  }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid>

                          
                          </Grid>
                        </TableCell> */}
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
          <Grid  sx={{ '@media print': {
                    display: 'none',
                  } }}
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={filteredPayments.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>

      
      </Grid>
    </Card>
   
      </Grid>

      <Grid item xs={12} sm={6} md={3}> 
      <Card>
        <CardContent>
          <HighchartsReact highcharts={Highcharts} options={paymentsPieChartOptions } />
        </CardContent>
      </Card>
    </Grid>

    <Grid item xs={12} sm={6} md={3}> 
      <Card>
        <CardContent>
        <HighchartsReact highcharts={Highcharts} options={paymentsDoughnutChartOptions } />
        </CardContent>
      </Card>
    </Grid>
      </Grid>
      </div>


      <Grid container spacing={4}  justifyContent="center" sx={{ marginTop: 3}}>

   

   
  </Grid>


      <div ref={componentRef} >
    <Grid container spacing={4}  sx={{ marginTop: 2 }}>
    <Grid item xs={12} sm={12} md={12}>

    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>Today's Due Invoices</Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid 
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{  display: "flex" ,'@media print': {
              display: 'none',
            } }}
          >
            <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Invoice Number .."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid>
            {dueInvoices.length > 0 && (
  <Grid item>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => componentRef.current}
    />
  </Grid>
)}
            
          </Grid>
        </Grid>
      </Grid>

      <Grid>
       <TableContainer
            sx={{
              maxHeight: 450, // Fixed height for the table
              overflowY: 'auto', // Enables vertical scrolling
            }}
            className={classes.thinScrollbar} 
            >
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                {/* <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Invoice Number</strong>
                </TableCell>
                  <TableCell className={classes.tablheader}>
                   <strong>Mode</strong>
                   </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Amount</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Paid Amt</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Balance</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Issue From</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Issue For</strong>
                </TableCell>
           
                {/* <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell> */}
                <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right",  '@media print': {
                    display: 'none',
                  } }}
                >
                  <strong>Actions</strong>
                </TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || dueInvoices.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                dueInvoices
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IInvoice, index) => {
                    const statusLabel = getStatusLabel(
                      row.quoteWorkOrderStatus
                    );
                    const statusColor = getStatusColor(
                      row.quoteWorkOrderStatus
                    );
                    const balance = Math.max(0, parseFloat(row.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(row.amount_paid || "0")));



                    return (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        {/* <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell> */}
                
                        <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                          sx={{ whiteSpace: "nowrap" }} 
                        >
                          {row.InvoiceNo}
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                         {row.Mode}
                        </TableCell>

                       <TableCell scope="row" className={classes.tablCell}>
                       <Button
                            className={classes.statusButtonList}
                            style={{
                              color: statusColor,
                              backgroundColor: row.quoteWorkOrderStatus === WorkOrderStatus.Paid
                              ? "#e1f8d5"
                              : row.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                              ? "#f8d7da"
                              : row.quoteWorkOrderStatus === WorkOrderStatus.Pending
                              ? "lightyellow"
                                : row.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                              ? "#e2fafa"
                              : "#ffffff", // Fallback for other statuses
                              border: "solid 1px",
                              borderColor: statusColor,
                              borderRadius: "8px",
                              
                            }}
                          >
                            {statusLabel}
                          </Button>
                                             </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                        >
                            {"$"}
                                  {parseFloat(
                                    row.quoteWorkOrderSaleGrandTotal || "0"
                                  ).toFixed(2)}
                         
                        </TableCell>
                        <TableCell  component="th" scope="row"  className={classes.tablCell}>
                            {"$"}{(row.amount_paid || "0" )}
                        </TableCell>
                       
                        <TableCell component="th" scope="row" className={classes.tablCell}>
                         {"$"}{balance.toFixed(2)}
                         </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                          {row.company.companyName || row.project.projectName || ""}
                       
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                          <Grid container>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                            {row.project?.projectName || row.customer?.customerCompanyName || ""}
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                            {row.customer ? (
        `${row.customer.customerFirstName?.charAt(0).toUpperCase() + row.customer.customerFirstName?.slice(1).toLowerCase() || ""} 
        ${row.customer.customerLastName?.charAt(0).toUpperCase() + row.customer.customerLastName?.slice(1).toLowerCase() || ""}`
      ) : ("Walk-in ")}
                            </Grid>
                          </Grid>
                        </TableCell>
                     
                        {/* <TableCell scope="row" className={classes.tablCell}>
                          <Button
                            className={classes.statusButtonList}
                            style={{
                              color: statusColor,
                              border: "solid 1px",
                              borderColor: statusColor,
                              borderRadius: "8px",
                            }}
                          >
                            {statusLabel}
                          </Button>
                        </TableCell> */}
                        <TableCell scope="row" className={classes.tablCell} sx={{ textAlign: "right",  '@media print': {
                    display: 'none',
                  } }}>
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >

                        
                            <Grid item>
                              <Button
                                variant="contained"
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/invoice/history/${row.id}`)
                                }
                              >
                                <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Grid>

                           

                          <Grid item>
                          <Button
  variant="contained"
  className={classes.editButtonList}
  onClick={() =>
    navigate(
      row.project?.id
        ? `/invoice/project/edit/${row.id}` // Redirect to project-specific edit page
        : `/invoice/edit/${row.id}` // Redirect to regular edit page
    )
  }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid>

                          
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
          <Grid  sx={{ '@media print': {
                    display: 'none',
                  } }}
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={accessibleInvoices.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>

      
      </Grid>
    </Card>
   
      </Grid>
      </Grid>
      </div>



      {/* <Grid container spacing={4} justifyContent="center" sx={{ marginTop: 1 }}>
      {Object.entries(categoryData).map(([categoryName, totalAmount]) => {
        const pieData = calculatePieData(categoryName); // Get pie chart data

        return (
          <Grid item xs={12} sm={4} md={4} key={categoryName}>
            <Card elevation={3} sx={{ height: '510px', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
                <Grid container direction="column" alignItems="center">
                 
                 
                  <Typography variant="body2" mt={2} align="center" sx={{ fontWeight: 'bold', fontSize: '15px' }}>
                  {categoryName}</Typography>


                 <Grid container direction="row" alignItems="center" spacing={2} sx={{ marginTop: '10px' }}>
        
          <Grid item md={8} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ width: '150px', height: '150px' }}>
            <Pie
  data={calculatePieData(categoryName)}
  options={{
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const { dataIndex, dataset } = tooltipItem;
            const totalValue = dataset.data.reduce((a, b) => a + b, 0); // Sum of all values in the dataset
            const value = dataset.data[dataIndex] as number;

            // Calculate the percentage for the category slice relative to totalExpense
            let percentage = "0.00";
            if (dataIndex === 0) {
              percentage = ((value / overallExpense) * 100).toFixed(2); // Percentage based on overallExpense
            }

            if (dataIndex === 0) {
              // Show category-specific percentage in tooltip
              return `${percentage}%`; // Display category percentage
            }
            // Show value for overall expense in tooltip
            return `${value.toFixed(2)}`;
          },
        },
      },
      legend: {
        display: true,
        labels: {
          color: '#000',
        },
      },
    },
  }}
/>

            </Box>
          </Grid>

     
          <Grid item md={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" >
                Total  {expenses.filter((expense) => categoryMap[expense.category] === categoryName).length}
              </Typography>
              <Typography variant="h3" sx={{ fontSize: '1.2rem'}}>
                {((categoryData[categoryName] / overallExpense ) * 100).toFixed(2)}%
          
           
              </Typography>
             
            </Box>
          </Grid>
        </Grid>

              
                  <Box
                    sx={{
                      flex: 1,
                      overflowY: 'auto',
                      maxHeight: '200px', // Ensure it is scrollable
                      width: '100%',
                      marginTop: 2, // Ensure space between the pie chart and the content below
                    }}
                    className={classes.thinScrollbar}
                  >
                    <Grid container direction="column" spacing={2}>
                      {expenses
                        .filter((expense) => categoryMap[expense.category] === categoryName)
                        .map((expense, index) => (
                          <Grid item key={index} container justifyContent="space-between">
                      
                            <Grid item xs={8}>
                              <Typography variant="body2">
                                {expense.date} <br />
                                {expense.description}
                              </Typography>
                            </Grid>

                     
                            <Grid item xs={4} textAlign="right">
                              <Typography variant="body2">
                                ${expense.total}
                              </Typography>
                            </Grid>

                            {index < expenses.length - 1 && (
                              <Grid item xs={12}>
                                <Box sx={{ borderBottom: '1px solid #ccc', my: 1 }} />
                              </Grid>
                            )}
                          </Grid>
                        ))}
                    </Grid>
                  </Box>

                 
                  <Grid container justifyContent="space-between" sx={{ padding: '16px', position: 'absolute', bottom: 0, left: 0, right: 0 }}>
          <Grid item xs={6}>
            <Typography variant="h6">Total Expense:</Typography>
            <Typography variant="body2" sx={{ fontSize: "1.00rem" }}>
              ${categoryData[categoryName]?.toFixed(2) || "0.00"}
            </Typography>
          </Grid>

          <Grid item xs={6} textAlign="right">
            <Typography variant="h6">Total HST:</Typography>
            <Typography variant="body2" sx={{ fontSize: "1.00rem" }}>
         
              ${((categoryHST[categoryName] ?? 0) as number).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>

                </Grid>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid> */}











      </>




       

  );
};

export default Index;
